import PropTypes from 'prop-types';
import React from 'react';

const Email = ({
  size
}) => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  "aria-label": "Cookie icon",
  viewBox: "0 0 85 85"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "49.67 47.65 27.52 33.28 27.52 37.75 49.64 52.1 72.52 37.65 72.52 33.38 49.67 47.65"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.75,74H26.29A6.27,6.27,0,0,1,20,67.73V30.88a5.63,5.63,0,0,1,5.62-5.63H74.39A5.64,5.64,0,0,1,80,30.88V67.73A6.28,6.28,0,0,1,73.75,74ZM25.64,29a1.88,1.88,0,0,0-1.87,1.88V67.73a2.52,2.52,0,0,0,2.52,2.52H73.75a2.52,2.52,0,0,0,2.52-2.52V30.88A1.88,1.88,0,0,0,74.39,29Z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#e60000",
  className: "cls-1",
  points: "16.27 35.53 -0.16 36.52 0.2 42.51 16.27 41.54 16.27 35.53"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#e60000",
  className: "cls-1",
  points: "16.27 45.74 0.42 46.7 0.79 52.69 16.27 51.75 16.27 45.74"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#e60000",
  className: "cls-1",
  points: "16.27 55.96 1.01 56.88 1.37 62.87 16.27 61.97 16.27 55.96"
}));

Email.defaultProps = {
  size: '100px'
};
Email.propTypes = {
  size: PropTypes.string
};
export default Email;